import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { StickyNote } from "lucide-react";

export function NoteModal({ contact, onClose, noteText, setNoteText, onSave, saving }) {
  return (
    <Dialog open={!!contact} onOpenChange={(o) => { if (!o && !saving) onClose(); }}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-zinc-100 text-base font-semibold flex items-center gap-2">
            <StickyNote className="h-4 w-4 text-amber-400" /> Anotacao — {contact?.nome}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <Textarea
            data-testid="note-textarea"
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            placeholder="Ex: cliente quer agendar, sensivel a preco, voltou apos 6 meses..."
            className="text-xs min-h-[120px] resize-none"
            maxLength={200}
          />
          <div className="flex items-center justify-between">
            <span className="text-[10px] text-zinc-600">{noteText.length}/200</span>
            <Button
              data-testid="note-save-btn"
              onClick={onSave}
              disabled={saving}
              className="bg-amber-500 text-zinc-950 hover:bg-amber-600 h-8 text-xs font-semibold disabled:opacity-50"
            >
              {saving ? "Salvando..." : "Salvar"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
